export default "__VITE_ASSET__omq8t3Wm__"